
import { Card, Col, Divider, Form, Input, Row, Space,Select  } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ButtonAction from 'components/Common/ButtonAction';
import { ButtonAdd } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import CustomAntdTable from 'components/Common/CustomAntdTable';
import { dismissToast, errorToast, successToast,loadingToastId } from 'utils/Toast';
import Constant from 'utils/Constants';
import { sorterTable } from 'utils/Helper';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
// import useAccessPermissionHook from 'hooks/useAccessPermissionHook';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import SkeletonPage from 'components/Common/SkeletonPage';
import { ButtonAdvanceFilter } from 'components/Common/ButtonAdvanceFilter';
import Error403 from 'components/Error/Error403';
import BaseAdvanceFilter from 'components/CustomDrawer/BaseAdvanceFilter';
import CellTable from 'components/Common/CellTable';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useOrgRepo from "../../../services/repo/useOrgRepo";

export default function Org() {

    useTopbarTitleHooks("Organization");
    const { isLoading: isLoadingList, getOrgList } = useOrgRepo(false)
    const { isLoading: isLoadingDelete,  deleteOrg} = useOrgRepo(false);

    const isMobile = useIsMobileHooks()
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const [data, setData] = useState()
    const [totalData, setTotalData] = useState(0)
    const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false)
 

    // const { isHasPrivilege } = useAccessPermissionHook()
    const isLoadingPrivilege = useRef(true)
    const hasPrivilegePage = useRef(true)
    const [isLoadedPrivilege, setIsLoadedPrivilege] = useState(false)
    const [showButtonAdd, setShowButtonAdd] = useState(false)

    const [filters, setFilters] = useState({
        orgName: "",
        // orgAddress: "",
        orgContactPerson: "",
        orgContactNo: "",
        status: ""
    })

    const [tableParams, setTableParams] = useState({
        pageNumber: 1,
        pageSize: 10,
        orderBy: "orgName",
        isAscending: true,
        filter: {
          orgName: "",
          orgContactPerson: "",
          orgContactNo: "",
          status: ""
        }
    });

    const onSearch = (value) => {
        setTableParams(prev => ({
            ...prev,
            pageNumber: 1,
            filter: {
                ...filters
            }
        }))
    };

    const onSearchClick = () => {
        onSearch()
        setIsOpenAdvanceFilter(false)
    }

    
    const fetchData = async () => {
        const payload = {
            ...tableParams
        }
        const res = await getOrgList(payload)
     
        if (res?.detail=='OK' && res?.status === 200) {
            setData(res?.data?.content)
            setTotalData(res?.data?.totalElements)
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pageNumber: pagination?.current,
            pageSize: pagination?.pageSize,
            orderBy: sorter?.field || prevParams?.orderBy,
            isAscending: sorterTable(sorter?.order, prevParams?.isAscending)
        }));
        if (pagination.pageSize !== tableParams?.pageSize) {
            setData([]);
        }
    };

    const handleAdd = () => {
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.organization.org.create);
    }

    const handleEdit = async (data) => {
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.organization.org.edit(data?.orgId))
    }

    const handleDelete = async (record) => {
        const key = 'deleteOrganization';
        try {

          debugger
        
          loadingToastId(Constant.message.loading, key)
      
          const response = await deleteOrg({ orgId: record.orgId });
      
          if (response?.status === 200 && response?.detail === 'OK') {
            successToast(Constant.message.deleteDataSuccess);
            fetchData(); 
          } else {
            errorToast(Constant.message.deleteDataFail);
          }
        } catch (error) {
          console.error('Error:', error);
          errorToast(Constant.message.deleteDataFail);
        } finally {
            dismissToast(key); 
          }
    };
      
    const fetchCheckPrivilege = async () => {
        setShowButtonAdd('Add')
        isLoadingPrivilege.current = false
        hasPrivilegePage.current = true;
        setIsLoadedPrivilege(true)
        fetchData();
        dismissToast(PRIVILEGE_ID.AddEditOrg);
    }

    useEffect(() => {
        fetchCheckPrivilege()
    }, [])

    useEffect(() => {
      
        if (isLoadedPrivilege) {
            fetchData();
        }
    }, [JSON.stringify(tableParams)]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (isLoadedPrivilege && !isMobile) {
                onSearch()
            }
        }, Constant.delayFilter);
        return () => clearTimeout(timeOutId);
    }, [filters]);

    const filterUI = () => {
        return (
            <Form layout="horizontal" form={form}>
                <Row gutter={16}>
                    <Col xs={24} sm={10} md={8}>
                        <Form.Item name='orgNameFilter' label="Filter By">
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterName}
                                onChange={(e) => {
                                    setFilters(prev => ({
                                        ...prev,
                                        orgName: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={10} md={6}>
                        <Form.Item name='orgContactPersonFilter'>
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterContactPerson}
                                onChange={e => {
                                    setFilters(prev => ({
                                        ...prev,
                                        orgContactPerson: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={10} md={6}>
                        <Form.Item name='orgContactNumberFilter'>
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterContactNo}
                                onChange={e => {
                                    setFilters(prev => ({
                                        ...prev,
                                        orgContactNo: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={10} md={4}>
                        <Form.Item name='statusFilter'>
                            <Select
                            allowClear
                            placeholder="Select Status"
                            onChange={(value) => {
                                setFilters(prev => ({
                                ...prev,
                                status: value
                                }));
                            }}
                            >
                            <Select.Option value="true">Active</Select.Option>
                            <Select.Option value="false">Inactive</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        )
    }

    const columns = [
        {
            title: 'Action',
            key: 'action',
            width: "50px",
            render: (_, record) => {
                const buttons = showButtonAdd ? ['edit', 'delete'] : ['delete']
                return (
                    <ButtonAction
                        buttons={buttons}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        data={record}
                        loadingDelete={isLoadingDelete}
                    />
                )
            }
        },
        {
            title: 'Name',
            dataIndex: 'orgName',
            sorter: true,
            width: "250px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Contact Person',
            dataIndex: 'orgContactPerson',
            width: "200px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Contact No',
            dataIndex: 'orgContactNo',
            width: "150px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Efficiency Factor',
            dataIndex: 'orgEfficiencyFactor',
            width: "120px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        // {
        //     title: 'Address',
        //     dataIndex: 'orgAddress',
        //     width: "150px",
        //     sorter: true,
        //     render: (data) => <CellTable data={data} />
        // },
        {
            title: 'Status',
            dataIndex: 'status',
            width: "100px",
            render: (data) => <CellTable data={String(data).toLowerCase() === "true" ? "Active" : "Inactive"} />        
        }
        
    ];
    return (
        <>
            {hasPrivilegePage.current ?
                <Space direction="vertical" size="large" className='space-vertical-flex'>
                    <Card size="big" bordered={false}>
                        {isLoadingPrivilege.current ? <SkeletonPage /> :
                            <>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={20} xl={18}>
                                        {showButtonAdd && <ButtonAdd onClick={handleAdd} />}
                                    </Col>
                                </Row>
                                <Divider dashed className='mb-1 mt-1' />

                                {isMobile ?
                                    <ButtonAdvanceFilter onClick={() => setIsOpenAdvanceFilter(true)} />
                                    : filterUI()
                                }

                                <CustomAntdTable
                                    columns={columns}
                                    dataSource={data}
                                    rowKey={"orgId"}
                                    tableParam={tableParams}
                                    totalData={totalData}
                                    loading={isLoadingList}
                                    onChange={handleTableChange}
                                    // rowClick={handleRowClick}
                                    // isOpenDrawer={isOpenDrawer}
                                    // idDataHighlight={idHighlightRow}
                                />
                            </>
                        }
                    </Card>
                </Space> : (<Error403 />)
            }

           

            {isOpenAdvanceFilter &&
                <BaseAdvanceFilter
                    onClose={() => setIsOpenAdvanceFilter(false)}
                    onSearchClick={onSearchClick}>
                    {filterUI()}
                </BaseAdvanceFilter>}
        </>
    )
}
